import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ITrackingDetail } from '../../../pipeline/interfaces/pipeline-activity-data';
import { PipelineActivityService } from '../../../pipeline/services/pipeline-activity.service';
import { NoDataActionType, NoDataSourceType, NoDataTypes } from '../../interfaces/no-data';

@Component({
    selector: 'app-loan-card-activity',
    templateUrl: './loan-card-activity.component.html',
    styleUrls: ['./loan-card-activity.component.css'],
})
export class LoanCardActivityComponent implements OnInit, OnChanges {
    loading: boolean = false;
    data: any[];

    noDataSelection: NoDataTypes;

    @Input() loanNumber: string;
    constructor(private _activityService: PipelineActivityService) {}

    ngOnInit(): void {
        this.noDataSelection = {
            action: NoDataActionType.emptySelect,
            searchTerm: 'Activity',
            componentTitle: 'loan activity',
            inputSource: NoDataSourceType.smallDataCard,
        };
    }

    ngOnChanges(changes: SimpleChanges) {
        this.load();
    }

    load() {
        this.loading = true;

        try {
            this._activityService.getLoanTracking(this.loanNumber).subscribe(
                (res) => {
                    this.data = res;

                    if (this.data && this.data.length != 0) {
                        this.data = this.data.sort(orderedDateCompare);
                    }

                    this.loading = false;
                },
                (error) => {
                    throw error;
                }
            );
        } catch (e) {
            this.loading = false;
            this.data = null;
        }
    }
}

function orderedDateCompare(a: ITrackingDetail, b: ITrackingDetail) {
    let aTime: number;
    let bTime: number;
    if (!a.orderedDate) {
        aTime = Infinity;
    } else {
        aTime = new Date(a.orderedDate).getTime();
    }
    if (!b.orderedDate) {
        bTime = Infinity;
    } else {
        bTime = new Date(b.orderedDate).getTime();
    }
    if (aTime < bTime) {
        return -1;
    }
    if (aTime > bTime) {
        return 1;
    }
    return 0;
}
